module.exports = __webpack_public_path__ + "static/media/github.b0677d12.svg";